import { dynamicList } from "@/mocks/chigua";
import SectionHead from "./SectionHead";
import Reveal from "@/components/feature/Reveal";
import { toneChip, type Tone } from "./tone";

const dotColor: Record<Tone, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function Dynamics() {
  return (
    <section id="dynamics" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionHead
            kicker="消息动态 · FEED"
            title="官方消息动态通知"
            subtitle="官方动态、功能更新与系统通知的实时记录,脉络清晰可回看。"
            more="完整动态时间线"
            moreHref="#dynamics"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* 动态时间轴 */}
          <Reveal className="lg:col-span-2">
            <div className="rounded-2xl border border-background-200/70 bg-background-50 p-5 md:p-6">
              <div className="relative">
                <div className="absolute left-[9px] top-2 bottom-2 w-px bg-background-200"></div>
                {dynamicList.map((d, i) => (
                  <div key={d.id} className="relative flex gap-4 py-2.5">
                    <span className={`relative z-10 mt-1 flex h-[19px] w-[19px] shrink-0 items-center justify-center rounded-full ${dotColor[d.tone as Tone]} ring-4 ring-background-100`}>
                      <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>
                    </span>
                    <div className={`flex-1 rounded-xl p-3.5 transition-colors ${i === 0 ? 'bg-accent-50' : 'bg-background-100/70 hover:bg-background-100'}`}>
                      <div className="flex flex-wrap items-center gap-2">
                        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${toneChip[d.tone as Tone]}`}>
                          {d.chip}
                        </span>
                        <span className="font-label text-xs text-foreground-400">{d.time}</span>
                        {i === 0 && (
                          <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-background-50">
                            <i className="ri-flashlight-fill"></i>刚刚
                          </span>
                        )}
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{d.text}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a
                href="#dynamics"
                className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-dashed border-background-300 py-3 text-sm font-medium text-foreground-600 transition-colors hover:border-accent-300 hover:text-accent-700"
              >
                加载更多历史动态
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </Reveal>

          {/* 订阅 + 渠道小卡 */}
          <Reveal delay={100}>
            <div className="flex flex-col gap-5">
              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 to-primary-700 p-5 text-background-50 md:p-6">
                <i className="ri-megaphone-fill absolute -right-4 -top-4 text-7xl text-background-50/10"></i>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium">
                  <i className="ri-notification-3-line"></i>
                  重要通知不再错过
                </span>
                <h3 className="font-heading mt-3 text-xl font-bold">订阅官方动态提醒</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                  按平台公告、功能更新等分类关注,关键官方消息第一时间推送到你面前。
                </p>
                <div className="mt-5 flex items-center gap-2 rounded-xl bg-background-50/15 p-1.5 backdrop-blur">
                  <i className="pl-2 text-base text-background-100/80 ri-arrow-right-line"></i>
                  <button type="button" className="whitespace-nowrap flex-1 rounded-lg bg-background-50 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100">
                    开启消息订阅
                  </button>
                </div>
              </div>

              <div className="rounded-2xl border border-background-200/70 bg-background-100 p-5 md:p-6">
                <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-line-chart-line text-primary-500"></i>
                  本日值得关注
                </h3>
                <ul className="mt-3 space-y-3">
                  {[
                    { t: '秋季版平台公约全量施行', n: '2.1w 人关注' },
                    { t: '消息中心交互体验升级', n: '9.6k 人关注' },
                    { t: '创作者扶持计划第二期报名', n: '5.8k 人关注' },
                  ].map((x) => (
                    <li key={x.t} className="flex items-center justify-between gap-2 rounded-lg bg-background-50 px-3 py-2.5">
                      <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                        <i className="ri-fire-fill text-secondary-500"></i>
                        {x.t}
                      </span>
                      <span className="whitespace-nowrap font-label text-xs text-foreground-400">{x.n}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}